import { render, staticRenderFns } from "./EnterName.vue?vue&type=template&id=4ac39012"
import script from "./EnterName.vue?vue&type=script&lang=js"
export * from "./EnterName.vue?vue&type=script&lang=js"
import style0 from "./EnterName.vue?vue&type=style&index=0&id=4ac39012&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports